// extracted by mini-css-extract-plugin
export default {"errorMessage":"styles_errorMessage__pz-3l","loading":"styles_loading__kRcFK","spinner":"styles_spinner__yVqMi"};